/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { PageSection } from "./PageSection";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface IPageNotFoundProps {}

/**
 * Page not found component
 *
 * @param props Props
 */
export function PageNotFound(props: IPageNotFoundProps) {

	const style = bem("page", "");

	return <div className={style.className()}>
		<header className={style.el("header").className()}>
			<h2 className={style.el("header-title").className()}>
				<span className={style.el("header-title-container").className()}>
					<span className={style.el("header-title-text").className()}>Stránka nebyla nalezena</span>
				</span>
			</h2>
		</header>
		<PageSection>
			<p>Prosím zkontrolujte zadanou URL adresu nebo vyberte sekci z nabídky.</p>
		</PageSection>
	</div>;

}
